import { DateTime } from 'luxon';

export function formatDateTime(date: DateTime | string): string {
  const dateTime = date instanceof DateTime ? date : DateTime.fromISO(date);
  const now = DateTime.now();

  // If less than 24 hours ago, show relative time (e.g., "2 hours ago")
  if (now.diff(dateTime, 'hours').hours < 24) {
    return dateTime.toRelative({ base: now });
  }

  // Otherwise show the date
  return dateTime.toLocaleString({
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}

export function getTimeLeft(end: DateTime, now: DateTime) {
  const days = Math.ceil(end.diff(now, 'days').days);
  if (days > 1) return { value: days, unit: 'days' };

  const hours = Math.ceil(end.diff(now, 'hours').hours);
  if (hours > 1) return { value: hours, unit: 'hours' };

  const minutes = Math.ceil(end.diff(now, 'minutes').minutes);
  if (minutes > 0) return { value: minutes, unit: 'minutes' };

  return null;
}
